import { useCallback, useState } from 'react';

export type ToastOptions = {
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
};

const toasts: Array<{ id: number; options: ToastOptions }> = [];
let toastId = 0;
let listener: (() => void) | null = null;

function notify() {
  listener?.();
}

export function useToast() {
  const [, setTick] = useState(0);
  const toast = useCallback((options: ToastOptions) => {
    toasts.push({ id: ++toastId, options });
    notify();
    setTick((t) => t + 1);
  }, []);
  return { toast };
}
